import makeCloudFunctionRequest from './makeCloudFunctionRequest';

export const deleteAlgoliaObject = (objectID, simplrAccountId, indexKey) => {
  return makeCloudFunctionRequest('deleteAlgoliaObject', { objectID, simplrAccountId, indexKey });
};

export const addAlgoliaObject = (object, simplrAccountId, indexKey) => {
  return makeCloudFunctionRequest('addAlgoliaObject', { object, simplrAccountId, indexKey });
};
